/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@scientifica-cms-fe/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    // {
    //     id: 'ssdf',
    //     title: 'Applications',
    //     type: 'basic',
    //     icon: 'heroicons_outline:clipboard-list',
    //     link: '/ssdf-call/lista',
    //     roles: ['Admin', "Authenticated", 'SSDF-Advisor']
    // },
    // {
    //     id: 'ssdf-dashboard',
    //     title: 'Dashboard',
    //     type: 'basic',
    //     icon: 'heroicons_outline:chart-pie',
    //     link: '/ssdf-call/dashboard',
    //     roles: ['Admin', "Authenticated"]
    // },
    // {
    //     id: 'ssdf-favorites',
    //     title: 'Preferiti',
    //     type: 'basic',
    //     icon: 'heroicons_outline:star',
    //     link: '/ssdf-call/preferiti',
    //     roles: ['Admin', "Authenticated", 'SSDF-Advisor']
    // },

];
export const horizontalNavigation: FuseNavigationItem[] = [
    // {
    //     id: 'home-grid',
    //     title: 'Configurazione Home',
    //     type: 'basic',
    //     icon: 'heroicons_outline:view-grid-add',
    //     link: '/home',
    //     roles: ['Authenticated', 'CMS - Collaborator', 'CMS - Approver']
    // },
    // {
    //     id: 'schede',
    //     title: 'Schede Iniziative',
    //     type: 'group',
    //     icon: 'heroicons_outline:clipboard-list',
    //     link: '',
    //     roles: ['Authenticated', 'Admin', 'Investment - Collaborator', 'Investment - Approver'],
    //     children: [
    //         {
    //             id: 'schede',
    //             title: 'Schede Valutazione',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-list',
    //             link: '/schedavalutazione',
    //             roles: ['Authenticated', 'Admin', 'Investment - Collaborator', 'Investment - Approver']
    //         },
    //         {
    //             id: 'schede',
    //             title: 'Schede Approfondimenti',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-list',
    //             link: '/scheda-approfondimenti',
    //             roles: ['Authenticated', 'Admin', 'Investment - Collaborator', 'Investment - Approver']
    //         },
    //         {
    //             id: 'scheda-travel',
    //             title: 'Scheda Travel Chart',
    //             type: 'basic',
    //             icon: 'heroicons_outline:clipboard-list',
    //             link: '/scheda-travel-chart',
    //             roles: ['Authenticated', 'Admin', 'CMS - Collaborator', 'CMS - Approver']
    //         },
    //     ]
    // },
    //
    // {
    //     id: 'feed',
    //     title: 'Feed News',
    //     type: 'basic',
    //     icon: 'heroicons_outline:clipboard-list',
    //     link: '/feed',
    //     roles: ['Authenticated']
    // },
    // {
    //     id: 'contacts',
    //     title: 'Contatti',
    //     type: 'group',
    //     icon: 'heroicons_outline:user-group',
    //     link: '',
    //     roles: ['Authenticated'],
    //     children: [
    //         {
    //             id: 'contacts_startup',
    //             title: 'Contatti Startup',
    //             type: 'basic',
    //             link: 'contacts/startup',
    //             roles: ['Authenticated'],
    //         },
    //         {
    //             id: 'contacts_career',
    //             title: 'Contatti Candidati',
    //             type: 'basic',
    //             link: 'contacts/career',
    //             roles: ['Authenticated'],
    //         },
    //         {
    //             id: 'contacts_press',
    //             title: 'Contatti Press',
    //             type: 'basic',
    //             link: 'contacts/press',
    //             roles: ['Authenticated'],
    //         },
    //         {
    //             id: 'contacts_sabbatical',
    //             title: 'Contatti Sabbatical',
    //             type: 'basic',
    //             link: 'contacts/sabbatical',
    //             roles: ['Authenticated'],
    //         },
    //         {
    //             id: 'contacts_general',
    //             title: 'Contatti Info',
    //             type: 'basic',
    //             link: 'contacts/info',
    //             roles: ['Authenticated'],
    //         },
    //     ]
    // },
    // {
    //     id: 'ssdf',
    //     title: 'Applications',
    //     type: 'basic',
    //     icon: 'heroicons_outline:clipboard-list',
    //     link: '/ssdf-call/lista',
    //     roles: ['Admin', "Authenticated", 'SSDF-Advisor']
    // },
    // {
    //     id: 'ssdf-dashboard',
    //     title: 'Dashboard',
    //     type: 'basic',
    //     icon: 'heroicons_outline:chart-pie',
    //     link: '/ssdf-call/dashboard',
    //     roles: ['Admin', "Authenticated"]
    // },
    // {
    //     id: 'ssdf-favorites',
    //     title: 'Preferiti',
    //     type: 'basic',
    //     icon: 'heroicons_outline:star',
    //     link: '/ssdf-call/preferiti',
    //     roles: ['Admin', "Authenticated", 'SSDF-Advisor']
    // },

    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/call-overview',
        roles: ['Admin']
    },
];
